import { render } from "./logo.vue?vue&type=template&id=51230284"
const script = {}
script.render = render

export default script